<template>
  <div :class="['our-services-tails', sub_class]">
    <div class="container">
      <div class="row d-flex our-services-tails--title-desc">
        <h2>{{ title }}</h2>
        <p class="description">{{ description }}</p>
      </div>
      <div class="row">
        <div
          class="tail-desktop col-l-6"
          :key="index"
          v-for="(service, index) in services"
        >
          <div class="tail-desktop__title">{{ service.name }}</div>
          <div
            class="
              tail-desktop__image
              notched
              notched__enabled
              notched__inside
              notched__mobile-inside
              notched--bottom
              notched--mobile-middle
              notched--white
            "
            :style="{
              'background-image': 'url(' + service.image.url + ')',
              'background-position':
                service.horizontal_position +
                '% ' +
                service.vertical_position +
                '%',
            }"
          >
            <div
              class="tail-desktop__image--caption"
              :style="{ color: service.image_caption_color }"
            >
              {{ service.image_caption }}
            </div>
          </div>
          <div
            class="tail-desktop__description"
            v-html="service.description"
          ></div>
        </div>
        <div
          class="tail-mobile"
          :key="service.name"
          v-for="(service, index) in services"
        >
          <div
            :class="[
              'tail-mobile__title',
              { 'tail-mobile__title-active': openAcordion === index },
            ]"
            @click="setActiveService(index)"
          >
            {{ service.name }}
          </div>
          <div class="tail-mobile__content" v-show="openAcordion === index">
            <div
              class="
                tail-mobile__image
                notched
                notched__enabled
                notched__inside
                notched__mobile-outside
                notched--bottom
                notched--mobile-middle
                notched--white
              "
              :style="{ 'background-image': 'url(' + service.image.url + ')' }"
            >
              <div
                class="tail-mobile__image--caption"
                :style="{ color: service.image_caption_color }"
              >
                {{ service.image_caption }}
              </div>
              <div class="notched-helper"></div>
            </div>
            <div
              class="tail-mobile__description"
              v-html="service.description"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "our-services-tails",
  props: ["blockdata"],
  data() {
    return {
      description: this.blockdata.description,
      openAcordion: -1,
      services: this.blockdata.services,
      sub_class: this.blockdata.class,
      title: this.blockdata.title,
    };
  },
  methods: {
    setActiveService: function (index) {
      this.openAcordion = this.openAcordion === index ? -1 : index;
    },
  },
};
</script>



// WEBPACK FOOTER //
// OurServicesTails.vue?a88eed06